import React from 'react'
import { AnalysisMap } from '@popety-io/ui'
import type { SectionType } from '../contexts'

export interface PublicLandAnalysisMapProps {
  propertyId: string
  coordinates?: [number, number]
  onResizeStart?: () => void
  geoJson?: any
  buildingGeoJson?: any
  buildingHeight?: number
  buildingDisplayHeight?: number
  buildingClassification?: string
  activeSection?: SectionType
  sectionData?: any
  hoveredItemId?: string | number | null
  selectedItemId?: string | number | null
  flyToCoordinates?: [number, number] | null
  onItemClick?: ((item: any) => void) | null
  setSelectedItemId?: ((id: string | number | null) => void) | null
}

export const PublicLandAnalysisMap: React.FC<PublicLandAnalysisMapProps> = ({
  propertyId,
  coordinates,
  onResizeStart,
  geoJson,
  buildingGeoJson,
  buildingHeight,
  buildingDisplayHeight,
  buildingClassification,
  activeSection,
  sectionData,
  hoveredItemId,
  selectedItemId,
  flyToCoordinates,
  onItemClick,
  setSelectedItemId,
}) => {
  return (
    <AnalysisMap
      isPublic
      propertyId={propertyId}
      coordinates={coordinates}
      analysisType="land"
      onResizeStart={onResizeStart}
      geoJson={geoJson}
      buildingGeoJson={buildingGeoJson}
      buildingHeight={buildingHeight}
      buildingDisplayHeight={buildingDisplayHeight}
      buildingClassification={buildingClassification}
      activeSection={activeSection}
      sectionData={sectionData}
      hoveredItemId={hoveredItemId}
      selectedItemId={selectedItemId}
      flyToCoordinates={flyToCoordinates}
      onItemClick={onItemClick}
      setSelectedItemId={setSelectedItemId}
      uiConfig={{
        showLayersButton: true,
        showLegendButton: true,
        show3DButton: true,
        showLocationButton: true,
      }}
    />
  )
}
